import { useAsertoApiWithAuth0Token, v1Api } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useTenantClient() {
  const { tenantServiceUrl } = useConfig()
  const tenantApi = `${v1Api(tenantServiceUrl)}/tenant`
  return useAsertoApiWithAuth0Token(tenantApi)
}
